module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAmCAYAAAC/H3lnAAAA3ElEQVRYR+2YMQ7CMBAEd/kHlFAinmE+4jYSPCRtXsJboCT/4KiQwEZKEZ90Kzm1cx6t99Yn08wSgAnAFrG+GUAmefvGopk9A8J+GGeSO3lgLUvEsu0yDZeXxFpRAV/SKZGvkKlhtskV8PV8jJ0a5YHLActZIlaL1TT6KdEVbqwA7T4kMOi0Zsg8jMW09hhi5+5+LKY1OWA1SzTuCfdy+jksdzXLDT9ywHKWcG/zlRvop8RKAdx/11O4v621NUV/W2ur52+1/8+tnjt61NZLiVIFuatZbviRA45uiTdyWXpFLmgP5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_v2/class_icon@2x.png
// module id = EFWX
// module chunks = 1